(() => {
  'use strict';

  const STYLE_ID = 'dt-media-gallery-enhanced-styles';
  const CSS = [
    "media-gallery.dt-enhanced-gallery [id^='GalleryViewer-']{position:relative}",
    ".dt-gallery-controls{position:absolute;inset:0;z-index:4;pointer-events:none}",
    ".dt-gallery-arrow{position:absolute;top:50%;display:grid;place-items:center;width:4.4rem;height:4.4rem;padding:0;transform:translateY(-50%);border:0;border-radius:50%;color:rgb(var(--color-foreground));background:transparent;box-shadow:none;opacity:.62;cursor:pointer;pointer-events:auto;transition:opacity 120ms ease,transform 120ms ease}",
    ".dt-gallery-arrow:hover{opacity:.9;background:transparent}",
    ".dt-gallery-arrow:focus-visible{outline:2px solid rgb(var(--color-foreground));outline-offset:3px;opacity:1}",
    ".dt-gallery-arrow svg{width:3.2rem;height:3.2rem;padding:.8rem;border:1px solid rgba(var(--color-foreground),.12);border-radius:50%;background:rgba(var(--color-background),.64);box-shadow:0 1px 3px rgba(0,0,0,.06)}",
    ".dt-gallery-arrow--prev{left:-.2rem}.dt-gallery-arrow--next{right:-.2rem}",
    ".dt-gallery-counter{position:absolute;left:50%;bottom:1rem;z-index:4;min-width:4.8rem;padding:.35rem .85rem;transform:translateX(-50%);border-radius:999px;color:rgb(var(--color-foreground));background:rgba(var(--color-background),.78);font-size:1.2rem;line-height:1.4;text-align:center;pointer-events:none}",
    ".dt-gallery-fade{animation:dt-gallery-fade 160ms ease-out}",
    "@keyframes dt-gallery-fade{from{opacity:.45}to{opacity:1}}",
    "media-gallery.dt-enhanced-gallery [id^='GalleryThumbnails-'] .thumbnail[aria-current='true']{outline:2px solid rgb(var(--color-foreground));outline-offset:2px}",
    "media-gallery.dt-enhanced-gallery [id^='GalleryThumbnails-'] .thumbnail:focus-visible{outline:2px solid rgb(var(--color-foreground));outline-offset:3px}",
    "media-gallery.dt-gallery-single .dt-gallery-controls,media-gallery.dt-gallery-single .dt-gallery-counter,media-gallery.dt-gallery-single .thumbnail-slider,media-gallery.dt-gallery-single>.slider-buttons{display:none!important}",
    "@media(max-width:749px){.dt-gallery-controls,.dt-gallery-counter{display:none!important}}",
    "@media(prefers-reduced-motion:reduce){.dt-gallery-fade{animation:none}.dt-gallery-arrow{transition:none}}"
  ].join('');

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function initGallery(gallery) {
    if (window.matchMedia('(max-width: 749px)').matches) {
      const mobileViewer = gallery.querySelector("[id^='GalleryViewer-']");
      const mobileNext = gallery.querySelector('.slider-button--next');
      const mobileCurrent = gallery.querySelector('.slider-counter--current');
      const mobileTotal = gallery.querySelector('.slider-counter--total');

      if (mobileViewer && mobileNext && mobileCurrent && mobileTotal) {
        const keepMobileNextEnabled = () => {
          mobileNext.disabled = false;
          mobileNext.removeAttribute('disabled');
        };

        mobileNext.addEventListener('click', (event) => {
          const currentIndex = Number.parseInt(mobileCurrent.textContent, 10);
          const totalCount = Number.parseInt(mobileTotal.textContent, 10);
          if (currentIndex !== totalCount) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          const mobileSlider = mobileViewer.slider || mobileViewer.querySelector('.slider');
          if (!mobileSlider) return;
          mobileSlider.scrollLeft = 0;
          mobileSlider.dispatchEvent(new Event('scroll'));
        }, { capture: true });

        new MutationObserver(keepMobileNextEnabled).observe(mobileNext, {
          attributes: true,
          attributeFilter: ['disabled']
        });
        keepMobileNextEnabled();
      }
      return;
    }
    if (gallery.dataset.dtGalleryEnhanced === 'true') return;
    const viewer = gallery.querySelector("[id^='GalleryViewer-']");
    if (!viewer) return;

    gallery.dataset.dtGalleryEnhanced = 'true';
    gallery.classList.add('dt-enhanced-gallery');

    const thumbnails = gallery.querySelector("[id^='GalleryThumbnails-']");
    const controls = document.createElement('div');
    const previous = document.createElement('button');
    const next = document.createElement('button');
    const counter = document.createElement('div');

    controls.className = 'dt-gallery-controls';
    previous.className = 'dt-gallery-arrow dt-gallery-arrow--prev';
    next.className = 'dt-gallery-arrow dt-gallery-arrow--next';
    counter.className = 'dt-gallery-counter';
    previous.type = 'button';
    next.type = 'button';
    previous.setAttribute('aria-label', (document.documentElement.lang.startsWith('en') ? 'Previous product image' : '前の商品画像'));
    next.setAttribute('aria-label', (document.documentElement.lang.startsWith('en') ? 'Next product image' : '次の商品画像'));
    counter.setAttribute('role', 'status');
    counter.setAttribute('aria-live', 'polite');
    counter.setAttribute('aria-atomic', 'true');
    previous.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M10.5 2.5 5 8l5.5 5.5"/></svg>';
    next.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m5.5 2.5 5.5 5.5-5.5 5.5"/></svg>';
    controls.append(previous, next);
    viewer.append(controls, counter);

    const slides = () => Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]'));
    const activeSlide = () => viewer.querySelector('.product__media-item[data-media-id].is-active') || slides()[0];
    const normalize = (index, length) => ((index % length) + length) % length;

    function thumbnailButton(mediaId) {
      if (!thumbnails || !mediaId) return null;
      const escaped = window.CSS && CSS.escape ? CSS.escape(mediaId) : mediaId.replace(/"/g, '\\"');
      const target = thumbnails.querySelector('[data-target="' + escaped + '"]');
      return target && (target.matches('button') ? target : target.querySelector('button'));
    }

    function syncThumbnail(mediaId) {
      if (!thumbnails) return;
      thumbnails.querySelectorAll('.thumbnail[aria-current]').forEach((button) => button.removeAttribute('aria-current'));
      const button = thumbnailButton(mediaId);
      if (!button) return;
      button.setAttribute('aria-current', 'true');
      const item = button.closest('li') || button;
      const scroller = thumbnails.querySelector('.thumbnail-list,.slider') || thumbnails;
      const itemRect = item.getBoundingClientRect();
      const viewRect = scroller.getBoundingClientRect();
      scroller.style.paddingInlineEnd = '';
      let spacer = scroller.querySelector('.dt-thumbnail-spacer');
      if (!spacer) {
        spacer = document.createElement(scroller.matches('ul,ol') ? 'li' : 'span');
        spacer.className = 'dt-thumbnail-spacer';
        spacer.setAttribute('aria-hidden', 'true');
        spacer.setAttribute('role', 'presentation');
        scroller.appendChild(spacer);
      }
      const spacerWidth = Math.max(0, viewRect.width - itemRect.width);
      spacer.style.cssText = 'display:block;flex:0 0 ' + spacerWidth + 'px;width:' + spacerWidth + 'px;min-width:' + spacerWidth + 'px;pointer-events:none;';
      if (itemRect.left < viewRect.left || itemRect.right > viewRect.right) {
        const firstButton = scroller.querySelector('[data-target]');
        const firstItem = firstButton ? (firstButton.closest('li') || firstButton) : null;
        const targetLeft = item.offsetLeft - (firstItem ? firstItem.offsetLeft : 0);
        scroller.scrollTo({ left: targetLeft, behavior: 'auto' });
      }
       

    }

    function preloadAround(items, index) {
      if (items.length < 2) return;
      [-1, 1].forEach((offset) => {
        const image = items[normalize(index + offset, items.length)].querySelector('img');
        if (!image) return;
        image.loading = 'eager';
        const source = image.currentSrc || image.src;
        if (source) {
          const preload = new Image();
          preload.src = source;
        }
      });
    }

    function updateUI(selected, announce) {
      const items = slides();
      const current = selected && items.includes(selected) ? selected : activeSlide();
      const index = Math.max(0, items.indexOf(current));
      const total = items.length;
      gallery.classList.toggle('dt-gallery-single', total <= 1);
      counter.textContent = total ? (index + 1) + ' / ' + total : '';
      counter.setAttribute('aria-label', total ? (document.documentElement.lang.startsWith('en') ? 'Product image ' : '商品画像 ') + (index + 1) + ' / ' + total : '');
      counter.setAttribute('aria-live', announce === false ? 'off' : 'polite');
      if (current) syncThumbnail(current.dataset.mediaId);
      preloadAround(items, index);
      if (announce === false) requestAnimationFrame(() => counter.setAttribute('aria-live', 'polite'));
    }

    function activate(index) {
      const items = slides();
      if (items.length <= 1) return;
      const selected = items[normalize(index, items.length)];
      const thumb = thumbnailButton(selected.dataset.mediaId);
      if (thumb) {
        thumb.click();
      } else if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(selected.dataset.mediaId, false);
      }
      requestAnimationFrame(() => {
        selected.classList.remove('dt-gallery-fade');
        void selected.offsetWidth;
        selected.classList.add('dt-gallery-fade');
        updateUI(selected, true);
      });
    }

    function move(direction) {
      const items = slides();
      if (items.length <= 1) return;
      const index = Math.max(0, items.indexOf(activeSlide()));
      activate(index + direction);
    }

    previous.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      move(-1);
    });
    next.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      move(1);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      const target = event.target;
      if (target && (target.closest('input,textarea,select,[contenteditable="true"]') || target.isContentEditable)) return;
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    });

    let touchStartX = 0;
    let touchStartY = 0;
    viewer.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });
    viewer.addEventListener('touchend', (event) => {
      if (!touchStartX || event.changedTouches.length !== 1) return;
      const deltaX = event.changedTouches[0].clientX - touchStartX;
      const deltaY = event.changedTouches[0].clientY - touchStartY;
      touchStartX = 0;
      touchStartY = 0;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
      move(deltaX < 0 ? 1 : -1);
    }, { passive: true });

    if (thumbnails) {
      const carouselButtons = thumbnails.querySelectorAll('.slider-button');
      const keepCarouselArrowsActive = () => {
        carouselButtons.forEach((button) => {
          button.disabled = false;
          button.hidden = false;
          button.removeAttribute('disabled');
          button.removeAttribute('hidden');
          button.removeAttribute('aria-hidden');
          button.style.visibility = 'visible';
        });
      };
      keepCarouselArrowsActive();
      carouselButtons.forEach((button) => {
        new MutationObserver(keepCarouselArrowsActive).observe(button, {
          attributes: true,
          attributeFilter: ['disabled', 'hidden', 'aria-hidden']
        });
      });
      thumbnails.addEventListener('click', (event) => {
        const arrow = event.target.closest('.slider-button--prev, .slider-button--next');
        if (!arrow) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        move(arrow.classList.contains('slider-button--next') ? 1 : -1);
        keepCarouselArrowsActive();
        requestAnimationFrame(() => requestAnimationFrame(keepCarouselArrowsActive));
      }, { capture: true });
      thumbnails.addEventListener('click', (event) => {
        const arrow = event.target.closest('.slider-button--prev, .slider-button--next');
        if (arrow) {
          move(arrow.classList.contains('slider-button--next') ? 1 : -1);
          requestAnimationFrame(() => requestAnimationFrame(() => {
            thumbnails.querySelectorAll('.slider-button').forEach((button) => {
              button.disabled = false;
              button.removeAttribute('disabled');
            });
          }));
          return;
        }
        const target = event.target.closest('[data-target]');
        if (!target) return;
        requestAnimationFrame(() => {
          const selected = slides().find((item) => item.dataset.mediaId === target.dataset.target);
          updateUI(selected || activeSlide(), true);
        });
      });
    }

    document.addEventListener('variant:change', () => requestAnimationFrame(() => updateUI(activeSlide(), false)));
    viewer.addEventListener('slideChanged', (event) => {
      updateUI(event.detail && event.detail.currentElement ? event.detail.currentElement : activeSlide(), true);
    });
    updateUI(activeSlide(), false);
  }

  function initAll() {
    installStyles();
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

